// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3F1eT","wrapper-nopadding":"wrapper-nopadding__29fWG","loading":"loading__gsfhp","error":"error__3P2JQ","table-loading":"table-loading__11R0p","empty-val":"empty-val__2zwI3","panelheader-tools":"panelheader-tools__37dS8","propsPanels":"propsPanels__2MS8-","new":"new__29CBQ","marginLm":"marginLm__2HGv2","marginRm":"marginRm__1aaIr","fullWidth":"fullWidth__1ar7P","fullHeight":"fullHeight__2172A","noData":"noData__xdOS2","gray":"gray__QYhK9","failgateway":"failgateway__1kx-f"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/ApplicationDetail/coms/BroadcastView/coms/Logs/styles.scss
// module id = 2182
// module chunks = 1